export const setMapBounds = (newMapBounds: any) => {
  return {
    type: 'set_map_bounds',
    payload: newMapBounds
  }
}
